import { GADataProps } from "@components/GAData/GAData";
import { VerticalLayoutFactory } from "@routes/Section/layouts/Verticals/utils/helpers";
import { VerticalsSectionPageData } from "@routes/Section/utils/types";

type VerticalsPageContentProps = VerticalsSectionPageData & {
  gaProps: GADataProps;
};

/** The vertical page content separated by vertical. */
const VerticalsPageContent = ({
  gaProps,
  ...data
}: VerticalsPageContentProps): React.ReactElement => {
  const VerticalLayout = VerticalLayoutFactory(data.vertical);

  if (typeof VerticalLayout === "undefined") return <></>;

  return <VerticalLayout {...data} gaProps={gaProps} />;
};

export default VerticalsPageContent;
